/* eslint-disable id-blacklist */
import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { ColumnType, defaultSupportedColumnTypes } from 'app/shared/utils/column-type.util';
import { parquetCompressionTypeOptions, parquetV2CompressionTypeOptions } from '../consts/v2Dataset-const';
import { adfModelTypeMap, fileTypeLinkedServiceTypes } from '../consts/adf-model-type-map-const';
import { maxRowsPerFileAndPrefixMetadata, sapDatasphereConnectors } from '../consts/metadata-consts';
import { GlobalVariables } from 'app/services/globals';

export const parquetMetadata: IDatasetTypeMetadata = {
    type: adfModelTypeMap.parquet.datasetType,
    displayName: stringResources.ModelName_ParquetDataset,
    supportLinkedServiceTypes: fileTypeLinkedServiceTypes.concat(__IS_FABRIC_DPE__ ? sapDatasphereConnectors : []),
    supportDeleteActivity: true,
    isSource: true,
    isSink: true,
    datasetKind: 'file',
    icon: {
        className: 'svg-i-20x20-Parquet'
    },
    isFirstClass: true,
    supportDataFlowWriteComplexStructure: true,
    category: ['File'],
    isV2FormatDataset: true,
    supportDataFlowSink: true,
    supportDataFlowSource: true,
    supportDataTypes: defaultSupportedColumnTypes.concat(ColumnType.Date),
    compressionOptions: __IS_FABRIC_DPE__ ? parquetV2CompressionTypeOptions : parquetCompressionTypeOptions,
    supportGetMetadataActivity: true,
    formatWriteSettingControls: [maxRowsPerFileAndPrefixMetadata],
    LogicalToPhysicalMapping: __IS_FABRIC_DPE__
        ? {
              // it is used by sink only
              boolean: 'BOOLEAN',
              sbyte: 'INT_8',
              int16: 'INT_16', // diff from v1, was INT_32
              int32: 'INT_32',
              int64: 'INT_64',
              byte: 'UINT_8', // diff rom v1, was INT_32
              uint16: 'UINT_16', // diff from v1, was INT_32
              uint32: 'UINT_32', // diff from v1, was INT_64
              uint64: 'UINT_64', // diff from v1, was DECIMAL
              decimal: 'DECIMAL',
              single: 'FLOAT',
              double: 'DOUBLE',
              date: 'DATE',
              datetime: 'INT96', // diff from v1, was INT_96
              datetimeoffset: 'INT96', // diff from v1, was INT_96
              timespan: 'TIME', // diff from v1, was INT_96
              guid: 'STRING', // diff from v1, was UTF8
              string: 'STRING', // diff from v1, was UTF8
              'byte[]': 'BYTE_ARRAY'
          }
        : {
              boolean: 'BOOLEAN',
              sbyte: 'INT_8',
              int16: 'INT_32',
              int32: 'INT_32',
              int64: 'INT_64',
              byte: 'INT_32',
              uint16: 'INT_32',
              uint32: 'INT_64',
              uint64: 'DECIMAL',
              decimal: 'DECIMAL',
              single: 'FLOAT',
              double: 'DOUBLE',
              datetime: 'INT_96',
              datetimeoffset: 'INT_96',
              timespan: 'INT_96',
              string: 'UTF8',
              guid: 'UTF8',
              char: 'UTF8',
              'byte[]': 'BINARY'
          },
    PhysicalToLogicalMapping: __IS_FABRIC_DPE__
        ? GlobalVariables.parquetMapping
            ? {
                  boolean: ColumnType.Boolean,
                  int_8: ColumnType.SByte,
                  int_16: ColumnType.Int16,
                  int_32: ColumnType.Int32,
                  int_64: ColumnType.Int64,
                  int32: ColumnType.Int32,
                  int64: ColumnType.Int64,
                  int96: ColumnType.DateTime,
                  uint_8: ColumnType.Byte,
                  uint_16: ColumnType.UInt16,
                  uint_32: ColumnType.UInt32,
                  uint_64: ColumnType.UInt64,
                  decimal: ColumnType.Decimal,
                  float: ColumnType.Single,
                  double: ColumnType.Double,
                  date: ColumnType.Date,
                  time_millis: ColumnType.DateTime, // diff from V1, was TimeSpan
                  time_micros: ColumnType.DateTime,
                  time_nanos: ColumnType.DateTime, // newly added in v2
                  timestamp_millis: ColumnType.DateTime,
                  timestamp_micros: ColumnType.DateTime,
                  timestamp_nanos: ColumnType.DateTime, // // newly added in v2
                  interval: ColumnType.UnsupportedType,
                  string: ColumnType.String,
                  utf8: ColumnType.String, // for backward compatibility
                  enum: ColumnType.String,
                  uuid: ColumnType.Guid,
                  json: ColumnType.UnsupportedType, // diff from v1, was Byte[]
                  bson: ColumnType.UnsupportedType, // diff from v1, was Byte[]
                  list: ColumnType.UnsupportedType,
                  map: ColumnType.UnsupportedType,
                  binary: ColumnType.ByteArray, // for backward compatibility
                  byte_array: ColumnType.ByteArray,
                  struct: ColumnType.UnsupportedType,
                  fixed_len_byte_array: ColumnType.ByteArray // diff from v1, was not supported
              }
            : undefined
        : {
              boolean: ColumnType.Boolean,
              int_8: ColumnType.SByte,
              int_16: ColumnType.Int16,
              int_32: ColumnType.Int32,
              int_64: ColumnType.Int64,
              int32: ColumnType.Int32,
              int64: ColumnType.Int64,
              int96: ColumnType.DateTime,
              uint_8: ColumnType.Byte,
              uint_16: ColumnType.UInt16,
              uint_32: ColumnType.UInt32,
              uint_64: ColumnType.UInt64,
              decimal: ColumnType.Decimal,
              float: ColumnType.Single,
              double: ColumnType.Double,
              date: ColumnType.DateTime,
              time: ColumnType.UnsupportedType,
              time_millis: ColumnType.TimeSpan,
              time_micros: ColumnType.UnsupportedType,
              timestamp: ColumnType.UnsupportedType,
              timestamp_millis: ColumnType.DateTime,
              timestamp_micros: ColumnType.UnsupportedType,
              interval: ColumnType.UnsupportedType,
              string: ColumnType.String,
              utf8: ColumnType.String,
              enum: ColumnType.ByteArray,
              uuid: ColumnType.ByteArray,
              json: ColumnType.ByteArray,
              bson: ColumnType.ByteArray,
              list: ColumnType.UnsupportedType,
              map: ColumnType.UnsupportedType,
              binary: ColumnType.ByteArray,
              struct: ColumnType.UnsupportedType,
              fixed_len_byte_array: ColumnType.UnsupportedType
          },
    LogicalToAdvancedTypeMapping: {
        boolean: {
            physicalTypes: ['BOOLEAN']
        },
        sbyte: {
            logicalTypes: ['INT'],
            physicalTypes: ['INT32']
        },
        int16: {
            logicalTypes: ['INT'],
            physicalTypes: ['INT32']
        },
        int32: {
            logicalTypes: ['INT'],
            physicalTypes: ['INT32']
        },
        int64: {
            logicalTypes: ['INT'],
            physicalTypes: ['INT64']
        },
        byte: {
            logicalTypes: ['INT'],
            physicalTypes: ['INT32']
        },
        uint16: {
            logicalTypes: ['INT'],
            physicalTypes: ['INT32']
        },
        uint32: {
            logicalTypes: ['INT'],
            physicalTypes: ['INT32']
        },
        uint64: {
            logicalTypes: ['INT'],
            physicalTypes: ['INT64']
        },
        decimal: {
            logicalTypes: ['DECIMAL'],
            physicalTypes: ['FIXED_LEN_BYTE_ARRAY', 'INT64', 'INT32'],
            propertyConfig: {
                precision: {
                    defaultValue: 38,
                    FIXED_LEN_BYTE_ARRAY: {
                        minValue: 19
                    },
                    INT64: {
                        minValue: 10,
                        maxValue: 18
                    },
                    INT32: {
                        minValue: 1,
                        maxValue: 9
                    }
                },
                scale: {
                    defaultValue: 18
                }
            }
        },
        single: {
            physicalTypes: ['FLOAT']
        },
        double: {
            physicalTypes: ['DOUBLE']
        },
        date: {
            logicalTypes: ['DATE'],
            physicalTypes: ['INT32']
        },
        datetime: {
            logicalTypes: [null, 'TIMESTAMP'],
            physicalTypes: ['INT96', 'INT64'],
            propertyConfig: {
                unit: {
                    defaultValue: 'NANOS',
                    INT64: ['MILLIS', 'MICROS', 'NANOS']
                }
            }
        },
        datetimeoffset: {
            logicalTypes: [null, 'TIMESTAMP'],
            physicalTypes: ['INT96', 'INT64'],
            propertyConfig: {
                unit: {
                    defaultValue: 'NANOS',
                    INT64: ['MILLIS', 'MICROS', 'NANOS']
                }
            }
        },
        timespan: {
            logicalTypes: ['TIME'],
            physicalTypes: ['INT64'],
            propertyConfig: {
                unit: {
                    defaultValue: 'NANOS',
                    INT64: ['NANOS'],
                    INT32: ['MILLIS']
                }
            }
        },
        guid: {
            logicalTypes: ['STRING', 'UUID'],
            physicalTypes: ['BYTE_ARRAY', 'FIXED_LEN_BYTE_ARRAY']
        },
        string: {
            logicalTypes: ['STRING'],
            physicalTypes: ['BYTE_ARRAY']
        },
        'byte[]': {
            physicalTypes: ['BYTE_ARRAY']
        }
    },
    advancedTypeIcons: {
        BOOLEAN: 'arg-type-icon svg-i-16x16-Bool',
        INT: 'arg-type-icon svg-i-16x16-Int',
        INT96: 'arg-type-icon svg-i-16x16-long',
        INT32: 'arg-type-icon svg-i-16x16-Int',
        INT64: 'arg-type-icon svg-i-16x16-long',
        DECIMAL: 'arg-type-icon svg-i-16x16-Decimal',
        FIXED_LEN_BYTE_ARRAY: 'arg-type-icon svg-i-16x16-long',
        FLOAT: 'arg-type-icon svg-i-16x16-float',
        DOUBLE: 'arg-type-icon svg-i-16x16-Double',
        DATE: 'arg-type-icon svg-i-16x16-Date',
        TIMESTAMP: 'arg-type-icon svg-i-16x16-Date',
        TIME: 'arg-type-icon svg-i-16x16-Date',
        STRING: 'arg-type-icon svg-i-16x16-String',
        UUID: 'arg-type-icon svg-i-16x16-String',
        BYTE_ARRAY: 'arg-type-icon svg-i-16x16-Any'
    }
};
